/**
 * Bildzeichen der App.
 *
 * Als Inline-SVG statt als Schriftart oder Bilddatei: Sie erben `currentColor`,
 * folgen damit ohne Zutun der Akzentfarbe der jeweiligen Disziplin, bleiben in
 * jeder Groesse scharf und kosten keine zusaetzliche Anfrage.
 *
 * Alle Zeichen sitzen im selben 24er-Raster mit gleicher Strichstaerke, sonst
 * wirken sie nebeneinander unruhig.
 */

interface IconProps {
  size?: number
  className?: string
}

function frame({ size = 24, className }: IconProps) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
  }
}

/** Langstrecke: ein Weg ohne Ende, der aus dem Bild laeuft. */
export function IconLangstrecke(props: IconProps) {
  return (
    <svg {...frame(props)}>
      <path d="M2 18c3 0 3-6 6-6s3 6 6 6 3-6 6-6 3 6 4 6" />
      <path d="M2 6h4M9 6h6M18 6h4" opacity="0.45" />
    </svg>
  )
}

/** Sprung: Absprung, Flugbahn, Landung. */
export function IconSprung(props: IconProps) {
  return (
    <svg {...frame(props)}>
      <path d="M3 19c0-7 4.5-11 9-11s6 2.5 6 5.5" />
      <path d="M15 13.5h3.5V10" />
      <circle cx="3" cy="19" r="1.6" fill="currentColor" stroke="none" />
      <path d="M14 20h7" opacity="0.45" />
    </svg>
  )
}

/** Sprint: die Stoppuhr. */
export function IconSprint(props: IconProps) {
  return (
    <svg {...frame(props)}>
      <circle cx="12" cy="13.5" r="7.5" />
      <path d="M12 13.5V9.5" />
      <path d="M9.5 2.5h5" />
      <path d="M12 2.5v3" />
      <path d="M18.8 7.2l1.5-1.5" opacity="0.45" />
    </svg>
  )
}

/** Bestenliste: der Pokal. */
export function IconPokal(props: IconProps) {
  return (
    <svg {...frame(props)}>
      <path d="M7 4h10v5a5 5 0 0 1-10 0V4Z" />
      <path d="M7 6H4.5v1.5A3.5 3.5 0 0 0 8 11" />
      <path d="M17 6h2.5v1.5A3.5 3.5 0 0 1 16 11" />
      <path d="M12 14v3M9 20h6M10 17h4" />
    </svg>
  )
}

/** Kalibrierung: das Massband. */
export function IconMassband(props: IconProps) {
  return (
    <svg {...frame(props)}>
      <rect x="2.5" y="7" width="19" height="10" rx="2" />
      <path d="M7 7v3M12 7v4M17 7v3" />
    </svg>
  )
}

/** Der Pfeil, der auf ein Ziel zeigt. */
export function IconPfeil(props: IconProps) {
  return (
    <svg {...frame(props)}>
      <path d="M5 12h13M13 7l5 5-5 5" />
    </svg>
  )
}
